import { MILLISECONDS_IN_MINUTE } from '../../../common/time.constants';

export const formatLocalDateToUtcTimestamp = (date: Date) => {
    const timezoneOffset = date.getTimezoneOffset() * MILLISECONDS_IN_MINUTE * -1;

    return date.getTime() + timezoneOffset;
};
